module.exports = __webpack_public_path__ + "img/icon_map_53_on_011.252d8d54.png";